import { Component, OnInit, Inject, EventEmitter, Output, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { FormGroup, FormBuilder } from '@angular/forms';
import { IHelp } from '@ebb-v2/ebb-integration';

@Component({
  selector: 'ebb-portal-program-rules-acknowledge',
  templateUrl: './program-rules-acknowledge.component.html'
})
export class ProgramRulesAcknowledgeComponent implements OnInit {
  @Output() emitProgramRulesAcknowledge = new EventEmitter<boolean>();
  @Input('listHelp') listHelp: IHelp[];
  @Input() 
  set programType(programType: any) {
    let acknowledgementName='ebbacknowledgement';

    switch (programType) {
      case 700000000: // CEA BB
        acknowledgementName = 'ceabbacknowledgement';
        break;
      case 700000003: // ESS
        acknowledgementName = 'essacknowledgement';
        break;
      case 700000004: // EMR
        acknowledgementName = 'emracknowledgement';
        break;
      default:
        acknowledgementName = 'ebbacknowledgement';
    }

    const indexHelpAcknowledge = this.listHelp.findIndex(i => i.name.toLowerCase() === acknowledgementName);

    if (indexHelpAcknowledge !== -1) {
      this.displayProgramRulesAcknowledgeContent = this.listHelp[indexHelpAcknowledge].answer;
    } 
  }

  public formPermissions: FormGroup;
  public displayTerms: boolean;
  public disableSave = true;
  public displayProgramRulesAcknowledgeContent:string;

  constructor(
    private readonly fb: FormBuilder  
  ) { }

  ngOnInit() {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.formPermissions = this.fb.group({
      confirmReviewedTerms: ''
    });
  }
  
  public onChangeEventTerms(event): void {
    this.disableSave = !event.checked;
  }

  public onClickYes(): void {
    this.emitProgramRulesAcknowledge.emit(true);
  }
}
